import { H3 } from "App/global-style";
import { RadioButton } from "Components/Form/RadioButton";
import { useTexts } from "Components/TextContext";
import { OptionLabel } from "Components/TextContext/commonComponentEnums";
import { VEHICLE_TYPE } from "Features/CheckPrice/Products/RiskProducts/VehicleProducts/vehicleConstants";
import { resetFindVehicle } from "Store/findVehicle/slice";
import { ReduxState } from "Store/rootReducer";
import { useFormikContext } from "formik";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FindVehicle } from "../FindVehicle";
import { FindVehicleType } from "../FindVehicleType";
import { findVehicleTextsCar } from "../FindVehicleType/utils";
import { CarProductIntroFormValues, VehicleInputType } from "../interfaces";
import { resetVehicle, resetVehicleType } from "../utils";

export const FindManualVehicle = ({
  displayTitle = true,
}: {
  displayTitle?: boolean;
}): React.ReactElement => {
  const formProps = useFormikContext<CarProductIntroFormValues>();
  const { values } = formProps;
  const dispatch = useDispatch();
  const { getText } = useTexts();

  const { current: vehicle } = useSelector(
    (state: ReduxState) => state.findVehicle,
  );

  useEffect(() => {
    if (vehicle) {
      formProps.setFieldValue("year", vehicle.registrationYear);
      formProps.setFieldValue("brand", vehicle.brand);
      formProps.setFieldValue("model", vehicle.model);
      if (vehicle.modelType) {
        formProps.setFieldValue("modelType", vehicle.modelType);
      }
    }
  }, [vehicle]);

  return (
    <>
      {displayTitle && <H3>{getText("carform.subheader.searchforcar")}</H3>}
      <RadioButton
        id="vehicleInputType"
        name="vehicleInputType"
        label={getText("carform.label.haveregistrationnumber")}
        onChange={() => {
          resetVehicle(formProps);
          resetVehicleType(formProps);
          dispatch(resetFindVehicle());
        }}
        options={[
          {
            label: getText(OptionLabel.BOOLEAN_YES),
            value: VehicleInputType.LICENSE_PLATE,
            id: `vechileInpytType-${VehicleInputType.LICENSE_PLATE}-yes`,
          },
          {
            label: getText(OptionLabel.BOOLEAN_NO),
            value: VehicleInputType.MANUAL,
            id: `vechileInpytType-${VehicleInputType.MANUAL}-no`,
          },
        ]}
      />
      {values.vehicleInputType == VehicleInputType.LICENSE_PLATE && (
        <FindVehicle />
      )}
      {values.vehicleInputType == VehicleInputType.MANUAL && (
        <FindVehicleType
          vehicleType={VEHICLE_TYPE.CAR}
          vehicleFetched={!!vehicle}
          formProps={formProps}
          texts={findVehicleTextsCar}
        />
      )}
    </>
  );
};
